import { Tree } from "antd";
import { useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function collectKeys(nodes) {
  const keys = [];
  nodes?.forEach((node) => {
    keys.push(node.key);
    if (node.children?.length) keys.push(...collectKeys(node.children));
  });
  return keys;
}

const ScreenTree = ({ label, name, options }) => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  return (
    <div className="mb-3">
      <div className="mb-1">
        <label htmlFor={name}>{label}</label>
      </div>
      <Field name={name}>
        {({ field, form }) => {
          const validKeys = new Set(collectKeys(options));
          const checkedKeys = (field.value ?? [])
            .map((item) => item.value)
            .filter((key) => validKeys.has(key));

          const onCheck = (checkedKeysValue) => {
            const claims = checkedKeysValue.map((key) => ({
              type: "permission",
              value: key,
              issuer: "IdentityService",
            }));
            form.setFieldValue(name, claims);
          };

          return (
            <Tree
              checkable
              treeData={options}
              checkedKeys={checkedKeys}
              onCheck={onCheck}
              expandedKeys={expandedKeys}
              autoExpandParent={autoExpandParent}
              onExpand={(keys) => {
                setExpandedKeys(keys);
                setAutoExpandParent(false);
              }}
            />
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
};

export default ScreenTree;
